/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";
import { WithinRangeString } from "@pagopa/ts-commons/lib/strings";

/**
 * Payment notice informations
 */

// required attributes
const PaymentNoticeR = t.interface({
  noticeNumber: WithinRangeString(18, 19),

  fiscalCode: WithinRangeString(11, 12),

  amount: t.Integer,

  companyName: t.string,

  description: t.string
});

// optional attributes
const PaymentNoticeO = t.partial({});

export const PaymentNotice = t.intersection(
  [PaymentNoticeR, PaymentNoticeO],
  "PaymentNotice"
);

export type PaymentNotice = t.TypeOf<typeof PaymentNotice>;
